import React, { ReactNode } from 'react';
import { useTranslation } from "../../hooks/useTranslation";

interface LayersProps {
	children: ReactNode;
}

const Layers: React.FC<LayersProps> = ({ children }) => {
	return <div>{children}</div>;
};

export default Layers;